<template>
    <div>
        <form @submit.prevent="searchPickupAddress">
            <v-layout row>
                <v-text-field
                        outlined
                        v-model="getPickUpAddress"
                        :label="label"
                        :placeholder="placeholder"
                        clearable
                        append-icon="search"
                        @click:append="searchPickupAddress"
                ></v-text-field>
                <v-progress-circular v-if="searchPickupSpinner" indeterminate color="blue"></v-progress-circular>
                <!--<v-btn v-if="!searchPickupSpinner" type="submit" icon><v-icon>search</v-icon></v-btn>-->
            </v-layout>
        </form>
        <v-dialog v-model="searchPickAddressDialog"
                  fullscreen
                  hide-overlay
                  transition="dialog-bottom-transition">
            <v-card>
                <v-app>
                        <v-container fluid fill-height>
                            <v-layout align-center justify-center>
                                <v-flex xs12 sm8 md4>
                                    <v-card class="elevation-12">
                                        <v-card-title><h2>Select an address</h2></v-card-title>
                                        <v-list v-if="searchPickAddresses.length !== 0"
                                                two-line>
                                            <v-list-item
                                                v-for="(location, i) in searchPickAddresses"
                                                    :key="i"
                                                    @click="pickUpAddressFound(i)"
                                            >
                                                    <v-list-item-avatar>
                                                        <v-icon class="error--text">location_on</v-icon>
                                                    </v-list-item-avatar>

                                                    <v-list-item-content>
                                                        <v-list-item-title v-html="location.name"></v-list-item-title>
                                                        <v-list-item-subtitle v-html="location.formatted_address"></v-list-item-subtitle>
                                                    </v-list-item-content>


                                            </v-list-item>
                                        </v-list>
                                        <v-card-text
                                                v-if="searchPickAddresses.length === 0"
                                        >
                                            No Addresses Found
                                        </v-card-text>
                                        <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn text @click="searchPickAddressDialog = false">cancel</v-btn>
                                        </v-card-actions>
                                    </v-card>
                                </v-flex>
                            </v-layout>
                        </v-container>
                </v-app>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
  export default {
    props: ['label', 'placeholder'],
    data() {
      return {
        pickUpAddressData: null,
        searchPickAddresses: [],
        getPickUpAddress: '',
        searchPickupSpinner: false,
        searchPickAddressDialog: false,
      }
    },
    computed: {
      addressReal () {
        if (this.pickUpAddressData !== null && this.dropOffAddressData !== null) {
          // Formatted addresses if both pick up and drop locations are searched by entering
          if (this.pickUpAddressData.geometry !== undefined) {
            let obj = {
              ...this.pickUpAddressData,
              latitude: this.pickUpAddressData.geometry.location.lat,
              longitude: this.pickUpAddressData.geometry.location.lng
            }
            return obj
          }
        }
      },
    },
    watch: {
      addressReal (value) {
        if (value) {
          this.$emit('locationFound', value)
        }
      }
    },
    methods: {
      pickUpAddressFound (index) {
        this.searchPickAddressDialog = false
        this.pickUpAddressData = this.searchPickAddresses[index]
        this.getPickUpAddress = this.searchPickAddresses[index].formatted_address
      },
      searchPickupAddress () {
        this.searchPickupSpinner = true

        let cors = 'https://trooper-cors.herokuapp.com/'
        let gmapPlacesApi = 'https://maps.googleapis.com/maps/api/place/findplacefromtext/json?input='
        // let gmapPlacesDetailApi = 'https://maps.googleapis.com/maps/api/place/details/json?placeid='
        // let placeId = 'ChIJN1t_tDeuEmsRUsoyG83frY4'
        // let placeDetailsParams = '&fields=name,rating,address_components,formatted_phone_number&key=AIzaSyD26ycH5aTtEunr0_FCDhXYNeK4CBdonxs'
        let params = '&inputtype=textquery&locationbias=point:43.6532,-79.3832&fields=formatted_address,name,rating,opening_hours,geometry&key=AIzaSyD26ycH5aTtEunr0_FCDhXYNeK4CBdonxs'
        let placeSearch = cors + gmapPlacesApi + this.getPickUpAddress + params
        // let placeDetails = cors + gmapPlacesDetailApi + placeId + placeDetailsParams
        this.axios.get(placeSearch)
          .then((response) => {
            this.searchPickAddressDialog = true
            this.searchPickupSpinner = false
            this.searchPickAddresses = response.data.candidates
          })
          .catch(err => {
            console.log(err)
          })
      }
    }
  }
</script>
